export default "__VITE_ASSET__QoC1Pfh6__"